"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandIndicator = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const common_1 = require("@/components/common");
/**
 * 펼침/접힘 상태를 나타내는 장식용 방향 표시.
 * 열고 닫는 상호작용은 트리거(버튼·메뉴 항목)가 소유하고, 이 요소는 expanded 상태만 받아 아이콘 회전으로 반영한다.
 */
let ExpandIndicator = class ExpandIndicator extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.expanded = false;
    }
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('aria-hidden', 'true');
    }
    render() {
        return (0, lit_1.html) `
      <mm-icon name=${common_1.ICON_NAMES.EXPAND}></mm-icon>
    `;
    }
};
ExpandIndicator.styles = (0, lit_1.css) `
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: var(--size-24);
      height: var(--size-24);
    }

    mm-icon {
      transition: transform var(--transition-duration) var(--transition-easing);
    }

    :host([expanded]) mm-icon {
      transform: rotate(180deg);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], ExpandIndicator.prototype, "expanded", void 0);
ExpandIndicator = __decorate([
    (0, decorators_js_1.customElement)('mm-expand-indicator')
], ExpandIndicator);
exports.ExpandIndicator = ExpandIndicator;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwYW5kLWluZGljYXRvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImV4cGFuZC1pbmRpY2F0b3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQTJDO0FBQzNDLHFEQUEyRDtBQUUzRCwrQkFBNEI7QUFDNUIsZ0RBQWdEO0FBRWhEOzs7R0FHRztBQUVJLElBQU0sZUFBZSxHQUFyQixNQUFNLGVBQWdCLFNBQVEsZ0JBQVU7SUFBeEM7O1FBa0J1QyxhQUFRLEdBQUcsS0FBSyxDQUFBO0lBWTlELENBQUM7SUFWQyxpQkFBaUI7UUFDZixLQUFLLENBQUMsaUJBQWlCLEVBQUUsQ0FBQTtRQUN6QixJQUFJLENBQUMsWUFBWSxDQUFDLGFBQWEsRUFBRSxNQUFNLENBQUMsQ0FBQTtJQUMxQyxDQUFDO0lBRUQsTUFBTTtRQUNKLE9BQU8sSUFBQSxVQUFJLEVBQUE7c0JBQ08sbUJBQVUsQ0FBQyxNQUFNO0tBQ2xDLENBQUE7SUFDSCxDQUFDOztBQTVCTSxzQkFBTSxHQUFHLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7O0dBZ0JsQixDQUFBO0FBQzJDO0lBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDO2lEQUFpQjtBQWxCakQsZUFBZTtJQUQzQixJQUFBLDZCQUFhLEVBQUMscUJBQXFCLENBQUM7R0FDeEIsZUFBZSxDQThCM0I7QUE5QlksMENBQWUifQ==